/* eslint-disable @typescript-eslint/no-explicit-any */
export type DynamicData = Record<string, any> | null | undefined;
export type RecordList = { [x: string]: any };
export type DomuiError =
  | ({
      statusCode?: string;
      message?: string;
      description?: string;
      errorResult?: ErrorResult;
    } & object)
  | undefined
  | null;

export type ErrorResult = {
  detail: string;
  errors: string | null;
  source: string;
  status: number;
  title: string;
  type: string;
};

export enum LogLevel {
  Debug = 'debug',
  Error = 'error',
  Info = 'info',
  Warn = 'warn',
}

export enum ClubType {
  RotaractClub = 'Rotaract Club',
  RotaractSatelliteClub = 'Rotaract Satellite Club',
  RotaryClub = 'Rotary Club',
  SatelliteClub = 'Satellite Club',
}

export enum ClubTypeFilterValue {
  RotaractClub = 'Rotaract Club',
  RotaractSatelliteClub = 'Rotaract Satellite Club',
  RotaryClub = 'Rotary Club',
  SatelliteClub = 'Satellite Club',
}

export enum FieldCharSet {
  OnlyDigits = 'OnlyDigits',
  OnlyLatin = 'OnlyLatin',
}

export enum FieldType {
  Date = 'Date',
  Number = 'Number',
  Options = 'Options',
  String = 'String',
}

export enum WeekdayShort {
  Friday = 'Fri',
  Monday = 'Mon',
  Saturday = 'Sat',
  Sunday = 'Sun',
  Thursday = 'Thurs',
  Tuesday = 'Tues',
  Wednesday = 'Wed',
}

export enum WeekdayLong {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
}

export enum AddressType {
  Business = 'Business',
  Home = 'Home',
  HostCountry = 'HostCountry',
  Localized = 'Localized',
  Project = 'Project',
  RotaryBusiness = 'Rotary Business',
}

export interface Role {
  startDate: string;
  endDate: string | null;
  individualRolePk: string;
  role: string;
  rolePk: string;
}
